export const ContempladosMasterData = [
    {
        id: 1,
        tipo: 'veiculo',
        credito: '25.700,00',
        entrada: '11.900,00',
        parcela: '383,00',
        prazo: '69 meses',
        checked: false
    },
    {
        id: 2,
        tipo: 'veiculo',
        credito: '30.900,00',
        entrada: '14.600,00',
        parcela: '570,00',
        prazo: '51 meses',
        checked: false
    },
    {
        id: 3,
        tipo: 'veiculo',
        credito: '33.400,00',
        entrada: '14.900,00',
        parcela: '632,00',
        prazo: '52 meses',
        checked: false
    },
    {
        id: 4,
        tipo: 'veiculo',
        credito: '35.850,00',
        entrada: '16.400,00',
        parcela: '563,00',
        prazo: '69 meses',
        checked: false
    },
    {
        id: 5,
        tipo: 'veiculo',
        credito: '37.450,00',
        entrada: '17.400,00',
        parcela: '542,00',
        prazo: '71 meses',
        checked: false
    },
    {
        id: 6,
        tipo: 'veiculo',
        credito: '40.800,00',
        entrada: '18.900,00',
        parcela: '746,00',
        prazo: '56 meses',
        checked: false
    },
    {
        id: 7,
        tipo: 'veiculo',
        credito: '48.335,00',
        entrada: '21.300,00',
        parcela: '808,00',
        prazo: '60 meses',
        checked: false
    },
    {
        id: 8,
        tipo: 'veiculo',
        credito: '55.550,00',
        entrada: '24.900,00',
        parcela: '924,00',
        prazo: '61 meses',
        checked: false
    },
    {
        id: 9,
        tipo: 'veiculo',
        credito: '62.100,00',
        entrada: '29.900,00',
        parcela: '979,00',
        prazo: '64 meses',
        checked: false
    },
    {
        id: 10,
        tipo: 'veiculo',
        credito: '77.000,00',
        entrada: '34.900,00',
        parcela: '1.034,00',
        prazo: '80 meses',
        checked: false
    },
    {
        id: 11,
        tipo: 'veiculo',
        credito: '91.370,00',
        entrada: '43.900,00',
        parcela: '1.060,00',
        prazo: '88 meses',
        checked: false
    },
    {
        id: 12,
        tipo: 'veiculo',
        credito: '108.000,00',
        entrada: '52.900,00',
        parcela: '1.284,00',
        prazo: '84 meses',
        checked: false
    },
    {
        id: 13,
        tipo: 'veiculo',
        credito: '137.903,00',
        entrada: '61.600,00',
        parcela: '1.378,00',
        prazo: '98 meses',
        checked: false
    },
    {
        id: 14,
        tipo: 'veiculo',
        credito: '142.614,00',
        entrada: '62.600,00',
        parcela: '1.457,00',
        prazo: '112 meses',
        checked: false
    },
    {
        id: 15,
        tipo: 'veiculo',
        credito: '159.300,00',
        entrada: '69.900,00',
        parcela: '2.072,00',
        prazo: '69 meses',
        checked: false
    },
    {
        id: 16,
        tipo: 'veiculo',
        credito: '189.777,00',
        entrada: '87.900,00',
        parcela: '2.048,00',
        prazo: '99 meses',
        checked: false
    },
    {
        id: 17,
        tipo: 'veiculo',
        credito: '220.328,00',
        entrada: '99.900,00',
        parcela: '2.525,00',
        prazo: '97 meses',
        checked: false
    },
    {
        id: 18,
        tipo: 'imovel',
        credito: '72.000,00',
        entrada: '29.900,00',
        parcela: '645,00',
        prazo: '134 meses',
        checked: false
    },
    {
        id: 19,
        tipo: 'imovel',
        credito: '83.200,00',
        entrada: '32.900,00',
        parcela: '707,00',
        prazo: '130 meses',
        checked: false
    },
    {
        id: 20,
        tipo: 'imovel',
        credito: '98.200,00',
        entrada: '43.000,00',
        parcela: '832,00',
        prazo: '110 meses',
        checked: false
    },
    {
        id: 21,
        tipo: 'imovel',
        credito: '114.500,00',
        entrada: '50.300,00',
        parcela: '1.018,00',
        prazo: '113 meses',
        checked: false
    },
    {
        id: 22,
        tipo: 'imovel',
        credito: '126.300,00',
        entrada: '55.700,00',
        parcela: '1.034,00',
        prazo: '127 meses',
        checked: false
    },
    {
        id: 23,
        tipo: 'imovel',
        credito: '147.550,00',
        entrada: '63.900,00',
        parcela: '1.205,00',
        prazo: '118 meses',
        checked: false
    },
    {
        id: 24,
        tipo: 'imovel',
        credito: '165.850,00',
        entrada: '72.900,00',
        parcela: '1.461,00',
        prazo: '130 meses',
        checked: false
    },
    {
        id: 25,
        tipo: 'imovel',
        credito: '182.000,00',
        entrada: '76.900,00',
        parcela: '1.464,00',
        prazo: '129 meses',
        checked: false
    },
    {
        id: 26,
        tipo: 'imovel',
        credito: '210.350,00',
        entrada: '91.900,00',
        parcela: '1.737,00',
        prazo: '139 meses',
        checked: false
    },
    {
        id: 27,
        tipo: 'imovel',
        credito: '239.450,00',
        entrada: '103.900,00',
        parcela: '1.837,00',
        prazo: '162 meses',
        checked: false
    },
    {
        id: 28,
        tipo: 'imovel',
        credito: '282.200,00',
        entrada: '126.900,00',
        parcela: '1.901,00',
        prazo: '158 meses',
        checked: false
    },
    {
        id: 29,
        tipo: 'imovel',
        credito: '311.800,00',
        entrada: '137.900,00',
        parcela: '2.203,00',
        prazo: '172 meses',
        checked: false
    },
    {
        id: 30,
        tipo: 'imovel',
        credito: '381.865,00',
        entrada: '157.900,00',
        parcela: '2.867,00',
        prazo: '143 meses',
        checked: false
    },
    {
        id: 31,
        tipo: 'imovel',
        credito: '417.000,00',
        entrada: '169.900,00',
        parcela: '2.508,00',
        prazo: '182 meses',
        checked: false
    },
    {
        id: 32,
        tipo: 'imovel',
        credito: '500.000,00',
        entrada: '221.900,00',
        parcela: '2.808,00',
        prazo: '218 meses',
        checked: false
    },
    {
        id: 33,
        tipo: 'imovel',
        credito: '586.243,00',
        entrada: '243.900,00',
        parcela: '4.458,00',
        prazo: '143 meses',
        checked: false
    },
    {
        id: 34,
        tipo: 'imovel',
        credito: '803.900,00',
        entrada: '359.900,00',
        parcela: '5.431,00',
        prazo: '190 meses',
        checked: false
    }
];